import React, { FC, useMemo } from "react";
import { EDetailSection } from "@/models/common/enums";
import styles from "@/styles/detail/DetailRecap.module.scss";
import { useStore } from "@/store/index";

type PackageDetailNavbarItemProps = {
    thisSection: EDetailSection;
    handleNavigation: (el: EDetailSection) => void;
    title: string;
};

const PackageDetailNavbarItem: FC<PackageDetailNavbarItemProps> = ({
    thisSection,
    handleNavigation,
    title,
}) => {
    const currentSection = useStore(state => state.packageState.currentSection);

    const spanClassName = useMemo(() => {
        return currentSection === thisSection
            ? styles.spanNavSelected
            : styles.spanNav;
    }, [thisSection, currentSection]);
    return (
        <span
            className={spanClassName}
            onClick={() => handleNavigation(thisSection)}
        >
            {title}
        </span>
    );
};

export default PackageDetailNavbarItem;
